export const getIsTimelineOpen = (state) => state.splatModel.isTimelineOpen
export const getPagesList = (state) => state.splatModel.pagesList
